// eslint-disable-next-line max-len
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M11.286 17v-4.286H7v-1.428h4.286V7h1.428v4.286H17v1.428h-4.286V17Z\"/></svg>";
